// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updatePinsNotRegisteredCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_PINS_NOT_REGISTERED_CRITERIA,
    value
});

export const resetCriteria = dealers => ({
    dealers,
    type: actions.RESET_PINS_NOT_REGISTERED_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/action-creators/criteria.js